import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  async canActivate(): Promise<boolean | UrlTree> {
    // First ensure user is authenticated (via AuthGuard)
    const cachedToken = await this.auth.getDecodedCachedToken();
    if (!cachedToken) {
      const token = await this.auth.getAccessToken();
      if (!token) {
        return this.router.parseUrl('/');
      }
    }

    // Now check if user has admin role
    const roles = this.auth.getUserRoles();
    const isAdmin = roles.includes('isAdmin');
    const isReadOnly = roles.includes('UserReadOnly');

    if (isAdmin || isReadOnly) {
      return true;
    }

    return this.router.parseUrl('/');
  }
}
